import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteObjectiveModal = ({ open, onClose, onDelete, objective }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('confirm_deletion') || 'Confirmar eliminación'}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('confirm_delete_objective') || '¿Estás seguro de que deseas eliminar el objetivo'} "{objective?.title}"?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t('action_cannot_be_undone') || 'Esta acción no se puede deshacer.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel') || 'Cancelar'}</Button>
        <Button onClick={onDelete} color="error" variant="contained">
          {t('delete') || 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteObjectiveModal;

